import { AxiosResponse } from "axios";
import AxiosService from "./Axios"
import BaseApi from "./BaseApi";

const BASE_URL = "/ai/conversation";

class AiConversationApi extends BaseApi {

    constructor() {
        super(BASE_URL);
    }

    public async clear(): Promise<AxiosResponse<any>> {
        return AxiosService.post(this.baseUrl + '/clear');
    }

}

export default AiConversationApi;